var _defs, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAddQuickAccess({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #8f003c;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "article_FILL0_wght400_GRAD0_opsz48",
    className: "cls-1",
    d: "M11.451,25.479H21V23.4H11.451Zm0-5.937h14.1V17.458h-14.1Zm0-5.937h14.1V11.521h-14.1ZM8.083,31A2.136,2.136,0,0,1,6,28.917V8.083A2.136,2.136,0,0,1,8.083,6H28.917A2.136,2.136,0,0,1,31,8.083V28.917A2.136,2.136,0,0,1,28.917,31Zm0-2.083H28.917V8.083H8.083Zm0-20.833v0Z",
    transform: "translate(-6 -6)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddQuickAccess);
export default __webpack_public_path__ + "static/media/add-quick-access.e0371ee8f124968c8a253a39c44f9a39.svg";
export { ForwardRef as ReactComponent };